import React, { Component } from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import withStyles from '@material-ui/core/styles/withStyles';
import Container from '@material-ui/core/Container';
import CircularProgress from '@material-ui/core/CircularProgress';
import '../styles/styles';

import firebase from '../util/firebase';  // <- neuer zentraler Import

const styles = (theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main
  },
  form: {
    width: '100%',
    marginTop: theme.spacing(1)
  },
  submit: {
    margin: theme.spacing(3, 0, 2)
  },
  customError: {
    color: 'red',
    fontSize: '0.8rem',
    marginTop: 10
  },
  progess: {
    position: 'absolute'
  }
});

class login extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
      password: '',
      errors: {},
      loading: false
    };
  }

  handleChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value
    });
  };

  handleSubmit = async (event) => {
    event.preventDefault();
    this.setState({ loading: true, errors: {} });

    const { email, password } = this.state;

    try {
      // 1) Bei Firebase einloggen
      const userCredential = await firebase
        .auth()
        .signInWithEmailAndPassword(email, password);

      // 2) ID-Token holen
      const token = await userCredential.user.getIdToken(); // kein force refresh hier nötig

      // 3) Wie bisher im LocalStorage speichern (Backend erwartet "Bearer <token>")
      localStorage.setItem('AuthToken', `Bearer ${token}`);

      this.setState({ loading: false });
      this.props.history.push('/');
    } catch (err) {
      console.error('Login error', err);

      let errors = {};

      // einfache Mapping-Beispiele
      switch (err.code) {
        case 'auth/invalid-email':
          errors.email = 'Ungültige E-Mail-Adresse';
          break;
        case 'auth/user-disabled':
          errors.general = 'Dieser Account wurde deaktiviert.';
          break;
        case 'auth/user-not-found':
        case 'auth/wrong-password':
          errors.general = 'E-Mail oder Passwort ist falsch.';
          break;
        default:
          errors.general = err.message || 'Login fehlgeschlagen';
      }

      this.setState({ errors, loading: false });
    }
  };

  render() {
    const { classes } = this.props;
    const { errors, loading } = this.state;

    return (
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <div className={classes.paper}>
          <Avatar className={classes.avatar}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Login
          </Typography>
          <form className={classes.form} noValidate>
            <TextField
              variant="standard"
              margin="normal"
              required
              fullWidth
              id="email"
              placeholder="Email Address"
              name="email"
              autoComplete="email"
              autoFocus
              helperText={errors.email}
              error={!!errors.email}
              onChange={this.handleChange}
            />
            <TextField
              variant="standard"
              margin="normal"
              required
              fullWidth
              name="password"
              placeholder="Password"
              type="password"
              id="password"
              autoComplete="current-password"
              helperText={errors.password}
              error={!!errors.password}
              onChange={this.handleChange}
            />
            <Button
              type="submit"
              className="save_button"
              fullWidth
              variant="contained"
              color="primary"
              onClick={this.handleSubmit}
              disabled={loading || !this.state.email || !this.state.password}
            >
              Sign In
              {loading && <CircularProgress size={30} className={classes.progess} />}
            </Button>
            <Grid container>
              <Grid item>
                <Link href="signup" variant="body2" className="pwlink">
                  {"Don't have an account? Sign Up"}
                </Link>
              </Grid>
            </Grid>
            {errors.general && (
              <Typography variant="body2" className={classes.customError}>
                {errors.general}
              </Typography>
            )}
          </form>
        </div>
      </Container>
    );
  }
}

export default withStyles(styles)(login);
